import { isProCodeComponentType } from './is-procode-component-type';
export function isLowCodeComponentType(desc) {
  return !isProCodeComponentType(desc);
}